import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
} from "@mui/material";
import SuccessIcon from "../../assets/checked.png";

export default function SuccessClaimedDialog({ open, onClose, onOk }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          px: 2,
          py: 3,
          maxWidth: 320,
          width: "100%",
          textAlign: "center",
        },
      }}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
          p: 1,
        }}
      >
        {/* ── Icon ── */}
        <Box
          component="img"
          src={SuccessIcon}
          alt="Success"
          sx={{ width: 64, height: 64, mb: 1 }}
        />

        {/* ── Title ── */}
        <Typography
          variant="h6"
          fontWeight={700}
          color="text.primary"
          lineHeight={1.3}
        >
          Successfully Claimed
        </Typography>

        {/* ── Subtitle ── */}
        <Typography variant="body2" color="text.secondary">
          Redirecting you to order history
        </Typography>

        {/* ── OK Button ── */}
        <Button
          fullWidth
          variant="contained"
          onClick={onOk ?? onClose}
          sx={{
            mt: 1,
            borderRadius: 3,
            py: 1.5,
            bgcolor: "#00A86B",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 16,
            boxShadow: "none",
            "&:hover": { bgcolor: "#009961", boxShadow: "none" },
          }}
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
}
